var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainContainer"},[_c('div',{staticStyle:{"display":"flex","flex-wrap":"wrap","gap":"15px","justify-content":"center","align-items":"center"}},_vm._l((_vm.tokenInfo),function(item,index){return _c('div',{class:_vm.calculateClass(item)},[_vm._v(" "+_vm._s(index + 1)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }